import { getSafeAreaBottom } from "@/utils/safe-area-bottom";
import { memo, type CSSProperties } from "react";

// Hand-drawn curved arrow pointing from the hint text to the FAB (Figma 399:4859).

export const CurvedArrow = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="62"
    viewBox="0 0 18 62"
    fill="none"
  >
    <g opacity="0.4">
      <path
        d="M7.61497 59.9651L1.36924 50.3098"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.01581 60.0303L17 52.8526"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.71655 59.3098C17.5 21.8098 7.71655 0.309753 7.71655 0.309753"
        stroke="black"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

/**
 * Coach hint shown on the filled My Plan v2 day while it has 1–3 items
 * (Figma 399:4787): a centered prompt and a curved arrow pointing at the FAB.
 * Purely presentational — visibility is controlled by the page.
 *
 * Offsets are derived from the Figma frame relative to the FAB (which sits at
 * `getSafeAreaBottom() + 81px`): the prompt's baseline is 116px above the FAB
 * (→ +197px) and the arrow box's bottom is ~20px above it (→ +101px), so the
 * whole hint tracks the FAB across devices.
 */
export const MyPlanAddGuide = memo(function MyPlanAddGuide() {
  return (
    <div className="pointer-events-none fixed inset-0 z-30 mx-auto max-w-[450px] text-black">
      <p
        className="absolute left-1/2 w-[230px] -translate-x-1/2 text-center font-[family-name:var(--font-crimson-text)] text-[18px] font-semibold opacity-80"
        style={{ bottom: `calc(${getSafeAreaBottom()} + 160px)` }}
      >
        Let NutriCoach know what you want to have <span className="text-os-brand">next</span>
      </p>
      <CurvedArrow
        className="absolute h-[62px] w-[18px]"
        style={{
          left: "50%",
          transform: "translateX(50%)",
          bottom: `calc(${getSafeAreaBottom()} + 92px)`,
        }}
      />
    </div>
  );
});
